const getPhotoSliceItems = (slice) => {
  const type = slice?.sliceType || slice?.slice_type;
  if (type !== 'photo' || !Array.isArray(slice?.items)) {
    return [];
  }
  return slice.items;
};

const isCarouselPhotoSlice = (slice) => getPhotoSliceItems(slice).length > 3;

/**
 * Photo slice shown in About the Author and removed from the article body.
 * Last carousel (4+ images) or last 3-up row — same rules as Mayflower relocation.
 */
export const findReadAuthorGalleryRelocateSlice = (body) => {
  if (!Array.isArray(body)) {
    return null;
  }

  const photoSlices = body.filter((slice) => getPhotoSliceItems(slice).length > 0);
  const carousel = [...photoSlices].reverse().find(isCarouselPhotoSlice);
  if (carousel) {
    return carousel;
  }

  return [...photoSlices].reverse().find((slice) => getPhotoSliceItems(slice).length === 3) || null;
};

/** @deprecated use findReadAuthorGalleryRelocateSlice */
export const findReadAuthorGalleryPhotoSlice = findReadAuthorGalleryRelocateSlice;

export const getReadAuthorGallerySliceId = (body) => findReadAuthorGalleryRelocateSlice(body)?.id || null;

const mapSliceToUrls = (slice) =>
  getPhotoSliceItems(slice)
    .map((item) => item?.image?.url || item?.image?.fluid?.src)
    .filter(Boolean);

/** Gallery images for About the Author (relocated from the article body). */
export const extractReadArticleGalleryUrls = (body) => {
  const slice = findReadAuthorGalleryRelocateSlice(body);
  if (!slice) {
    return [];
  }
  return mapSliceToUrls(slice);
};
